import { createClient } from '@supabase/supabase-js';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured.');
}
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true }
});
export default supabase;
